import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Campaigns from './pages/Campaigns';
import CampaignSteps from './pages/CampaignSteps';
import Templates from './pages/Templates';
import Leads from './pages/Leads';
import LeadDetail from './pages/LeadDetail';
import Logs from './pages/Logs';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import TopHeader from './components/TopHeader';
import { authService } from './services/auth';
import { ToastContainer } from './components/Toast';
import { useToast } from './hooks/useToast';
import {
  DashboardIcon,
  CampaignsIcon,
  TemplatesIcon,
  LeadsIcon,
  LogsIcon,
  LogoutIcon,
  RocketIcon,
} from './components/Icons';
import './App.css';

// Navigation component that uses useLocation - must be inside Router
function Navigation() {
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Dashboard', icon: DashboardIcon },
    { path: '/campaigns', label: 'Campaigns', icon: CampaignsIcon },
    { path: '/templates', label: 'Templates', icon: TemplatesIcon },
    { path: '/leads', label: 'Leads', icon: LeadsIcon },
    { path: '/logs', label: 'Logs', icon: LogsIcon },
  ];

  const handleLogout = () => {
    authService.logout();
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
          <RocketIcon size={24} />
          <div>
            <div style={{ fontWeight: 'var(--font-weight-bold)' }}>Outreach CRM</div>
            <div style={{ fontSize: 'var(--font-size-xs)', opacity: 0.8 }}>Aixcellence LLC</div>
          </div>
        </div>
      </div>
      <nav className="sidebar-nav">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path || 
            (item.path !== '/' && location.pathname.startsWith(item.path));
          const IconComponent = item.icon;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${isActive ? 'active' : ''}`}
            >
              <span className="nav-icon">
                <IconComponent size={20} />
              </span>
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
      <div style={{ padding: 'var(--spacing-md)', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <button
          onClick={handleLogout}
          className="nav-item"
          style={{
            width: '100%',
            background: 'transparent',
            border: 'none',
            color: 'rgba(255,255,255,0.8)',
            cursor: 'pointer',
            textAlign: 'left'
          }}
        >
          <span className="nav-icon">
            <LogoutIcon size={20} />
          </span>
          <span>Logout</span>
        </button>
        <div style={{ fontSize: 'var(--font-size-xs)', color: 'rgba(255,255,255,0.6)', marginTop: 'var(--spacing-sm)' }}>
          v1.0.0
        </div>
      </div>
    </aside>
  );
}

// Main App component
function App() {
  const toast = useToast();

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <>
                <Navigation />
                <main className="main-content">
                  <TopHeader />
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <ProtectedRoute>
                          <Dashboard />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/campaigns"
                      element={
                        <ProtectedRoute>
                          <Campaigns />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/campaigns/:campaignId/steps"
                      element={
                        <ProtectedRoute>
                          <CampaignSteps />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/templates"
                      element={
                        <ProtectedRoute>
                          <Templates />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/leads"
                      element={
                        <ProtectedRoute>
                          <Leads />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/leads/:leadId"
                      element={
                        <ProtectedRoute>
                          <LeadDetail />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/logs"
                      element={
                        <ProtectedRoute>
                          <Logs />
                        </ProtectedRoute>
                      }
                    />
                  </Routes>
                </main>
              </>
            }
          />
        </Routes>

        <ToastContainer toasts={toast.toasts} removeToast={toast.removeToast} />
      </div>
    </Router>
  );
}

export default App;
